module.exports = __webpack_public_path__ + "media/images/emblems/Goldach-02cdc25eb5b9c62f444d7843a66f56e9.png";